<template lang="pug">
  div.about
    h1 Widgets With Modal
    p This screen assumes your system has all information from another page.
    p Note the gray item in the middle asynchronously loads the rates and is clickable when ready.
    div.cross-sells
      div.cross-sell(v-for="spam in [1, 2, 3, 4]")
        h3 Add Another thing
        p Ooh shiny
      div.cross-sell.highlighted(@click="visible = !loading && ready" :class="{ ready }")
        h3 Add MMP
        p(v-if="loading") Loading rates...
        p(v-else-if="ready") Protect your vehicle!!!
        p(v-else) Error quoting
      div.cross-sell(v-for="spam in [1, 2, 3, 4]")
        h3 Add Another thing
        p Ooh shiny
    modal.translucent(:visible="visible")
      button.dismiss(@click="visible = !visible") Cancel
      swbc-sales-frame.frame(@error="loadDone($event)" @quote="loadDone" mode="selection" :quote="quoteRequest")
</template>

<script>
  import { mapGetters } from 'vuex'
  import Modal from '@/components/Modal'
  import SwbcSalesFrame from '@/components/SwbcSalesFrame'
  export default {
    name: 'WidgetsWithModal',
    data () {
      return {
        visible: false,
        loading: true,
        ready: false
      }
    },
    methods: {
      loadDone (rates) {
        this.loading = false
        this.ready = !!rates
        console.log('rates')
        console.log(rates)
      }
    },
    computed: {
      ...mapGetters(['quoteRequest'])
    },
    components: {
      Modal,
      SwbcSalesFrame
    }
  }
</script>


<style lang="sass">
  .about
    display: flex
    flex-direction: column
    align-items: center
    .translucent
      background-color: rgba(0, 0, 0, 0.6)
    .frame
      width: 60vw
      height: 60vh
      top: calc((100% - 600px) / 2)
      left: calc((100% - 800px) / 2)
    button.dismiss
      position: absolute
      width: 100px
      height: 50px
      line-height: 24px
      font-size: 22px
      cursor: pointer
    .cross-sells
      display: flex
      width: 50%
      flex-wrap: wrap
      justify-content: space-between
    .cross-sell
      padding: 10px
      margin: 10px 0
      border: 1px solid black
      border-radius: 3px
      width: 200px
      height: 100px
      &.highlighted
        background-color: #ccc
        &.ready
          cursor: pointer
</style>
